import * as React from "react";
import { cn } from "../../../helpers";
import styles from "./TextArea.module.scss";

export interface TextAreaProps
    extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    label?: string;
    hasError?: boolean;
    errorText?: string;
    errorTextClassName?: string;
    className?: string;
    name?: string;
    isRequired?: boolean;
}

const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
    (
        {
            label,
            hasError,
            name,
            errorText,
            className,
            errorTextClassName,
            isRequired,
            ...props
        },
        ref
    ) => {
        const baseClass = cn(
            styles.textarea,
            {
                [styles.hasError]: hasError,
            },
            className
        );

        if (label) {
            return (
                <div className={styles.textareaWrapper}>
                    <div className={styles.labelGroup}>
                        <label htmlFor={name}>
                            {label}
                            {isRequired && (
                                <span
                                    className={styles.required}
                                    aria-label="required"
                                >
                                    *
                                </span>
                            )}
                        </label>
                        <textarea
                            className={cn(baseClass, {
                                [styles.hasError]: hasError,
                            })}
                            name={name}
                            id={name}
                            ref={ref}
                            autoCorrect="on"
                            spellCheck="true"
                            {...props}
                        />
                        {errorText && (
                            <span
                                className={cn(styles.errorText, errorTextClassName)}
                            >
                                {errorText}
                            </span>
                        )}
                    </div>
                </div>
            );
        }

        return (
            <div className={styles.textareaWrapper}>
                <div className={styles.labelGroup}>
                    <textarea
                        className={cn(baseClass, {
                            [styles.hasError]: hasError,
                        })}
                        name={name}
                        id={name}
                        ref={ref}
                        autoCorrect="on"
                        spellCheck="true"
                        {...props}
                    />
                    {errorText && (
                        <span className={cn(styles.errorText, errorTextClassName)}>
                            {errorText}
                        </span>
                    )}
                </div>
            </div>
        );
    }
);

TextArea.displayName = "TextArea";

export { TextArea };
